export const SIDES = ["buy", "sell"] as const;

export type Side = (typeof SIDES)[number];

export const ORDER_TYPES = [
  "market",
  "limit",
  "stop",
  "stop_limit",
  "trailing_stop",
] as const;

export type OrderType = (typeof ORDER_TYPES)[number];

export const ORDER_TYPE_OPTIONS: {
  label: string;
  value: OrderType;
}[] = [
  {
    label: "Market",
    value: "market",
  },
  {
    label: "Limit",
    value: "limit",
  },
  {
    label: "Stop",
    value: "stop",
  },
  {
    label: "Stop Limit",
    value: "stop_limit",
  },
  {
    label: "Trailing Stop",
    value: "trailing_stop",
  },
];

export const TRAIL_TYPES = ["trail_price", "trail_percent"] as const;

export type TrailType = (typeof TRAIL_TYPES)[number];

export const TRAIL_TYPE_OPTIONS: {
  label: string;
  value: TrailType;
}[] = [
  {
    label: "Trailing Price",
    value: "trail_price",
  },
  {
    label: "Trailing Percent",
    value: "trail_percent",
  },
];

export const QUANTITY_TYPES = ["shares", "dollars"] as const;

export type QuantityType = (typeof QUANTITY_TYPES)[number];

export const TIME_IN_FORCE = [
  "day",
  "gtc",
  "fok",
  "ioc",
  "opg",
  "cls",
] as const;

export type TimeInForce = (typeof TIME_IN_FORCE)[number];

export const EQUITY_TIME_IN_FORCE_OPTIONS: {
  label: string;
  subLabel?: string;
  value: TimeInForce;
  orderTypes: OrderType[];
  extendedHoursOrderTypes: OrderType[];
}[] = [
  {
    label: "DAY",
    value: "day",
    orderTypes: ["market", "limit", "stop", "stop_limit", "trailing_stop"],
    extendedHoursOrderTypes: ["limit"],
  },
  {
    label: "GTC",
    subLabel: "Expires in 90 days",
    value: "gtc",
    orderTypes: ["market", "limit", "stop", "stop_limit", "trailing_stop"],
    extendedHoursOrderTypes: ["limit"],
  },
  {
    label: "FOK",
    subLabel: "Fill or Kill",
    value: "fok",
    orderTypes: ["market", "limit", "stop", "stop_limit"],
    extendedHoursOrderTypes: [],
  },
  {
    label: "IOC",
    subLabel: "Immediate or Cancel",
    value: "ioc",
    orderTypes: ["market", "limit", "stop", "stop_limit"],
    extendedHoursOrderTypes: [],
  },
  {
    label: "OPG",
    subLabel: "At the Open",
    value: "opg",
    orderTypes: ["market", "limit", "stop", "stop_limit"],
    extendedHoursOrderTypes: [],
  },
  {
    label: "CLS",
    subLabel: "At the Close",
    value: "cls",
    orderTypes: ["market", "limit", "stop", "stop_limit"],
    extendedHoursOrderTypes: [],
  },
];

/** GTC + IOC only — used for tokenized equity (.TOKEN) when feature flag is on. */
export const TOKENIZED_EQUITY_TIME_IN_FORCE_OPTIONS: {
  label: string;
  subLabel?: string;
  value: TimeInForce;
  orderTypes: OrderType[];
}[] = [
  {
    label: "GTC",
    subLabel: "Expires in 90 days",
    value: "gtc",
    orderTypes: ["market", "limit", "stop", "stop_limit", "trailing_stop"],
  },
  {
    label: "IOC",
    subLabel: "Immediate or Cancel",
    value: "ioc",
    orderTypes: ["market", "limit", "stop", "stop_limit"],
  },
];
